import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import { Modal } from "../../../../app/components";
import PrimaryButton from "../../../../app/components/buttons/primary";
import OutlinedButton from "../../../../app/components/buttons/outlined";

const TITLE = "You Have Unsaved Changes";
const MESSAGE =
  "Are you sure you want to exit without saving your changes first? Select an action below to continue.";

const UnsavedChangesModal = ({
  open = false,
  onToggle,
  title = TITLE,
  message = MESSAGE,
  buttons = [],
}) => {
  return (
    <Modal
      open={open}
      onClose={onToggle}
      aria-labelledby="clone study plan"
      aria-describedby="clone a study plan"
      title={title}
    >
      <Typography>{message}</Typography>
      <Container>
        {buttons.map((button, index) => {
          const ButtonComponent = button.variant === "primary" ? PrimaryButton : OutlinedButton;
          return (
            <ButtonComponent key={index} onClick={button.onClick}>
              {button.label}
            </ButtonComponent>
          );
        })}
      </Container>
    </Modal>
  );
};

export default UnsavedChangesModal;

const Container = styled.div`
  margin-top: 2em;
  display: flex;
  justify-content: flex-end;
  gap: 1em;
`;
